import { SvgHttpLoader } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { environment } from '@env';

export class SvgHttpLoaderCustom extends SvgHttpLoader {
  override getSvg(url: string): Observable<string> {
    if (environment.baseHref.length > 1) {
      return super.getSvg(environment.baseHref + url);
    }
    return super.getSvg(url);
  }
}
